'use client';

import { useEffect, useRef, useState } from 'react';
import { DAttachmentUploadMeta } from '@/src/modules/chat/data/dtos/attachment-upload-meta';
import { useChatStore } from '@/src/shared/stores/use-chat-store';
import { ChatComposerContext } from './contexts';

export function ChatComposerProvider({ children }: React.PropsWithChildren) {
  const invoiceNumber = useChatStore((state) => state.invoiceNumber);
  const resetChatStoreState = useChatStore((state) => state.resetState);

  const getContent = () => {
    if (invoiceNumber) {
      return `Pengaduan Pesanan - ${invoiceNumber}\nMasalahnya:\n`;
    }
    return '';
  };

  const [content, setContent] = useState<string>(getContent());
  const [attachments, setAttachments] = useState<DAttachmentUploadMeta[]>([]);
  const resetFileUploadRef = useRef<(() => void) | null>(null);

  const addAttachments = (metas: DAttachmentUploadMeta[]) => {
    setAttachments((prev) => {
      return [...prev, ...metas];
    });
  };

  const removeAttachment = (id: string) => {
    const meta = attachments.find((file) => file.id === id);
    if (!meta) {
      return;
    }

    URL.revokeObjectURL(meta.previewUrl);
    setAttachments((prev) => {
      return prev.filter((file) => file.id !== id);
    });
    resetFileUploadRef.current?.();
  };

  const clearAttachments = () => {
    attachments.forEach((file) => URL.revokeObjectURL(file.previewUrl));
    setAttachments([]);
    resetFileUploadRef.current?.();
  };

  const resetState = () => {
    setContent('');
    clearAttachments();
    resetChatStoreState();
  };

  // useEffect(() => {
  //   resetChatStoreState();
  // }, []);

  useEffect(() => {
    if (invoiceNumber) {
      setContent(`Pengaduan Pesanan - ${invoiceNumber}\nMasalahnya:\n`);
    }
  }, [invoiceNumber]);

  return (
    <ChatComposerContext.Provider
      value={{
        content,
        setContent,
        attachments,
        addAttachments,
        removeAttachment,
        clearAttachments,
        resetState,
        resetFileUploadRef,
      }}
    >
      {children}
    </ChatComposerContext.Provider>
  );
}
